module.exports = __webpack_public_path__ + "img/compose-a-led-lighting-system.50ba3db3.png";